import { Navigate } from 'react-router-dom';

/**
 * Protected route component that waits for auth to finish loading
 * before deciding whether to show the component or redirect
 */
const ProtectedRoute = ({ children, user, loading }) => {
  // Wait for auth to finish loading
  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>Loading...</div>;
  }
  
  // If not loading and no user, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  // User is authenticated, show the component
  return children;
};

export default ProtectedRoute;



